import React from 'react';
import {FaPen, FaTrash} from "react-icons/fa";
import Button from "../../../../../../components/button/button.jsx";

const GenericEditRemoveCellRenderer = ({data, setData, setOpen, remove, noEdit = true}) => {
    const edit = () => {
        setOpen(true)
        setData(data)
    }

    return (
        <div className="flex gap-1 justify-center items-center h-full w-full">
            {
                noEdit &&
                <Button onClick={edit} className={"!w-[30px] !h-[25px] !p-0"}>
                    <FaPen />
                </Button>
            }
            <Button target={"danger"} onClick={() => remove(data)} className={"!w-[30px] !h-[25px] !p-0"}>
                <FaTrash />
            </Button>
        </div>
    );
};

export default GenericEditRemoveCellRenderer;